// extracted by mini-css-extract-plugin
module.exports = {"card":"HomeBanner-module--card--3ox2G","title":"HomeBanner-module--title--3Q_tm","subText":"HomeBanner-module--subText--2_WRM"};